<div fxLayout="row" class="layout-row">
    <ng-container *ngFor="let command of commands">
        <command *ngIf="command.isVisible" [command]="command" [dense]="dense"
                 attr.telemetry="Command-{{command.label}}-CmdBar-Commands">
        </command>
    </ng-container>
</div>
